(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["search-modal"] && !Shopify.designMode) return;
  try {
    
  class SearchModalDrawer extends HTMLElement {
    connectedCallback() {
      this.overlay = this.querySelector('[data-search-modal-overlay]');
      this.dialog = this.querySelector('.search-modal__dialog');
      this.input = this.querySelector('[data-search-modal-input]');
      this.form = this.querySelector('[data-search-modal-form]');
      this.body = this.querySelector('[data-search-modal-body]');
      this.panelIdle = this.querySelector('[data-panel-idle]');
      this.panelResults = this.querySelector('[data-panel-results]');
      this.resultsGrid = this.querySelector('[data-results-grid]');
      this.resultsCount = this.querySelector('[data-results-count]');
      this.loadingEl = this.querySelector('[data-loading]');
      this.emptyEl = this.querySelector('[data-empty]');
      this.viewAllEl = this.querySelector('[data-view-all-results]');
      this.recentlyViewedSection = this.querySelector('[data-recently-viewed-section]');
      this.recentlyViewedGrid = this.querySelector('[data-recently-viewed-grid]');
      this.statusEl = this.querySelector('[data-search-modal-status]');

      this.minChars = parseInt(this.dataset.minChars || '2', 10);
      this.debounceMs = parseInt(this.dataset.debounce || '300', 10);
      this.resultsLimit = parseInt(this.dataset.resultsLimit || '8', 10);
      this.closeOnOutsideClick = this.dataset.closeOnOutsideClick === 'true';
      this.closeOnEscape = this.dataset.closeOnEscape === 'true';
      this.currency = this.dataset.moneyCurrency || 'USD';
      this.locale = this.dataset.moneyLocale || 'en';

      this._lastFocused = null;
      this._searchTimer = null;
      this._searchToken = 0;

      this.trackRecentlyViewed();
      this.renderRecentlyViewed();
      this.bindTriggers();
      this.bindDialogEvents();
    }

    bindTriggers() {
      document.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-search-modal-trigger]');
        if (trigger) {
          event.preventDefault();
          this.open();
        }
      });
      document.addEventListener('search-modal:open', () => this.open());
      document.addEventListener('search-modal:close', () => this.close());
    }

    bindDialogEvents() {
      this.querySelector('[data-search-modal-close]').addEventListener('click', () => this.close());

      if (this.closeOnOutsideClick) {
        this.overlay.addEventListener('click', () => this.close());
      }

      document.addEventListener('keydown', (event) => {
        if (!this.classList.contains('is-open')) return;
        if (this.closeOnEscape && event.key === 'Escape') this.close();
        if (event.key === 'Tab') this.trapFocus(event);
      });

      this.input.addEventListener('input', () => {
        const query = this.input.value.trim();
        clearTimeout(this._searchTimer);
        if (query.length < this.minChars) {
          this.showPanel('idle');
          return;
        }
        this._searchTimer = setTimeout(() => this.search(query), this.debounceMs);
      });

      this.form.addEventListener('submit', (event) => {
        const query = this.input.value.trim();
        if (query.length === 0) event.preventDefault();
      });

      this.querySelectorAll('[data-trending-term]').forEach((chip) => {
        chip.addEventListener('click', () => {
          this.input.value = chip.dataset.trendingTerm;
          this.input.dispatchEvent(new Event('input'));
          this.input.focus();
        });
      });
    }

    open() {
      this._lastFocused = document.activeElement;
      this.classList.add('is-open');
      this.overlay.hidden = false;
      this.dialog.hidden = false;
      document.body.style.overflow = 'hidden';
      requestAnimationFrame(() => {
        this.classList.add('is-open');
        this.input.focus();
      });
    }

    close() {
      this.classList.remove('is-open');
      document.body.style.overflow = '';
      setTimeout(() => {
        this.overlay.hidden = true;
        this.dialog.hidden = true;
      }, 320);
      if (this._lastFocused && typeof this._lastFocused.focus === 'function') {
        this._lastFocused.focus();
      }
    }

    trapFocus(event) {
      const focusable = this.dialog.querySelectorAll(
        'a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])'
      );
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    showPanel(name) {
      const showResults = name === 'results';
      this.panelIdle.hidden = showResults;
      this.panelResults.hidden = !showResults;
    }

    routeRoot() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    }

    formatMoney(amount) {
      try {
        return new Intl.NumberFormat(this.locale, { style: 'currency', currency: this.currency }).format(amount);
      } catch (error) {
        return '$' + Number(amount).toFixed(2);
      }
    }

    async search(query) {
      const token = ++this._searchToken;
      this.showPanel('results');
      this.loadingEl.hidden = false;
      this.emptyEl.hidden = true;
      this.resultsGrid.innerHTML = '';
      if (this.statusEl) this.statusEl.textContent = 'Searching for ' + query;

      const url =
        this.routeRoot() +
        'search/suggest.json?q=' +
        encodeURIComponent(query) +
        '&resources[type]=product&resources[limit]=' +
        this.resultsLimit +
        '&resources[options][unavailable_products]=last';

      try {
        const response = await fetch(url);
        const data = await response.json();
        if (token !== this._searchToken) return;

        const products = (data.resources && data.resources.results && data.resources.results.products) || [];
        this.loadingEl.hidden = true;

        if (this.statusEl) {
          this.statusEl.textContent = products.length + ' results found for ' + query;
        }

        if (!products.length) {
          this.emptyEl.hidden = false;
          if (this.viewAllEl) this.viewAllEl.hidden = true;
          return;
        }

        const showPrice = this.resultsGrid.dataset.showPrice === 'true';
        const showVendor = this.resultsGrid.dataset.showVendor === 'true';

        this.resultsGrid.innerHTML = products
          .map((product) => this.renderPredictiveCard(product, showPrice, showVendor))
          .join('');

        if (this.viewAllEl) {
          this.viewAllEl.hidden = false;
          this.viewAllEl.href = this.routeRoot() + 'search?q=' + encodeURIComponent(query) + '&type=product';
        }
      } catch (error) {
        if (token !== this._searchToken) return;
        this.loadingEl.hidden = true;
        this.emptyEl.hidden = false;
      }
    }

    renderPredictiveCard(product, showPrice, showVendor) {
      const price = parseFloat(product.price);
      const compareAt = parseFloat(product.compare_at_price_max || product.price);
      const onSale = compareAt > price;
      const image = product.image
        ? '<img src="' + product.image + '" alt="' + this.escapeHtml(product.title) + '" loading="lazy">'
        : '';

      return (
        '<a href="' +
        product.url +
        '" class="search-modal__card">' +
        '<span class="search-modal__card-media">' +
        image +
        (onSale ? '<span class="search-modal__badge">Sale</span>' : '') +
        '</span>' +
        '<span class="search-modal__card-body">' +
        (showVendor && product.vendor
          ? '<span class="search-modal__card-vendor">' + this.escapeHtml(product.vendor) + '</span>'
          : '') +
        '<span class="search-modal__card-title">' +
        this.escapeHtml(product.title) +
        '</span>' +
        (showPrice
          ? '<span class="search-modal__card-price">' +
            this.formatMoney(price) +
            (onSale ? '<s class="search-modal__card-compare">' + this.formatMoney(compareAt) + '</s>' : '') +
            '</span>'
          : '') +
        '</span>' +
        '</a>'
      );
    }

    trackRecentlyViewed() {
      const handle = this.dataset.currentProductHandle;
      if (!handle) return;
      try {
        let stored = JSON.parse(localStorage.getItem('search_modal_recently_viewed') || '[]');
        stored = stored.filter((item) => item !== handle);
        stored.unshift(handle);
        stored = stored.slice(0, 20);
        localStorage.setItem('search_modal_recently_viewed', JSON.stringify(stored));
      } catch (error) {
        /* localStorage unavailable, skip tracking */
      }
    }

    async renderRecentlyViewed() {
      if (!this.recentlyViewedGrid || !this.recentlyViewedSection) return;

      let stored = [];
      try {
        stored = JSON.parse(localStorage.getItem('search_modal_recently_viewed') || '[]');
      } catch (error) {
        stored = [];
      }

      const currentHandle = this.dataset.currentProductHandle;
      if (currentHandle) stored = stored.filter((item) => item !== currentHandle);

      const maxItems = parseInt(this.recentlyViewedGrid.dataset.maxItems || '4', 10);
      stored = stored.slice(0, maxItems);
      if (!stored.length) return;

      const showPrice = this.recentlyViewedGrid.dataset.showPrice === 'true';
      const root = this.routeRoot();

      const products = await Promise.all(
        stored.map((handle) =>
          fetch(root + 'products/' + handle + '.js')
            .then((response) => (response.ok ? response.json() : null))
            .catch(() => null)
        )
      );

      const cards = products
        .filter(Boolean)
        .map((product) => this.renderRecentlyViewedCard(product, showPrice))
        .join('');

      if (!cards) return;

      this.recentlyViewedGrid.innerHTML = cards;
      this.recentlyViewedSection.hidden = false;
    }

    renderRecentlyViewedCard(product, showPrice) {
      const price = product.price / 100;
      const compareAt = (product.compare_at_price || product.price) / 100;
      const onSale = compareAt > price;
      const image = product.featured_image || (product.images && product.images[0]) || null;
      const imageTag = image
        ? '<img src="' + image + '" alt="' + this.escapeHtml(product.title) + '" loading="lazy">'
        : '';

      return (
        '<a href="' +
        product.url +
        '" class="search-modal__card">' +
        '<span class="search-modal__card-media">' +
        imageTag +
        (onSale ? '<span class="search-modal__badge">Sale</span>' : '') +
        '</span>' +
        '<span class="search-modal__card-body">' +
        '<span class="search-modal__card-title">' +
        this.escapeHtml(product.title) +
        '</span>' +
        (showPrice
          ? '<span class="search-modal__card-price">' +
            this.formatMoney(price) +
            (onSale ? '<s class="search-modal__card-compare">' + this.formatMoney(compareAt) + '</s>' : '') +
            '</span>'
          : '') +
        '</span>' +
        '</a>'
      );
    }

    escapeHtml(value) {
      const div = document.createElement('div');
      div.textContent = value || '';
      return div.innerHTML;
    }
  }

  if (!customElements.get('search-modal-drawer')) {
    customElements.define('search-modal-drawer', SearchModalDrawer);
  }

  } catch(e) { console.error(e); }
})();
})();
